<footer>
    <div class="copyright">Copyright {{currentYear}} © Kindertons Accident Management</div>
</footer>
